import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { MediaItemModel } from '../../../../../models/media-item.model';

@Component({
  selector: 'slider-dialog-image-zoomed',
  templateUrl: './slider-dialog-image-zoomed.component.html',
})
export class SliderDialogImageZoomedComponent implements OnInit, AfterViewInit {

  @ViewChild('imageElement') public imageElement: ElementRef;

  @Input() public image: MediaItemModel = null;
  @Input() public clickPosX: number = 0;
  @Input() public clickPosY: number = 0;
  @Input() public containerWidth: number;
  @Input() public containerHeight: number;
  @Input() public factorX: number = 1;
  @Input() public factorY: number = 1;

  public posX: number = 0;
  public posY: number = 0;
  public maxLeftValue: number;
  public maxTopValue: number;
  public edgeOffsetX: number;
  public edgeOffsetY: number;
  public imageStyles: object;
  public containerStyles: object;
  public overlayStyles: object;

  /**
   * Constructor
   *
   * @param {ChangeDetectorRef} cdr
   */
  public constructor(private cdr: ChangeDetectorRef) { }

  /**
   * Setting initial values for the styles
   *
   * @return void
   */
  public ngOnInit(): void {
    this.imageStyles = {
      top: '0px',
      left: '0px',
    };
    this.containerStyles = {
      'max-width': this.containerWidth + 'px',
      'max-height': this.containerHeight + 'px',
    };
    this.overlayStyles = {
      width: this.containerWidth + 'px',
      height: this.containerHeight + 'px',
    };
  }

  /**
   * Sets the values and the event listener
   *
   * @return void
   */
  public ngAfterViewInit(): void {
    // The maximum values that the top and left attributes of the image can be set to
    this.maxLeftValue = this.imageElement.nativeElement.offsetWidth - this.containerWidth;
    this.maxTopValue = this.imageElement.nativeElement.offsetHeight - this.containerHeight;

    // The amount of pixels from each edge to act as a dead zone. Moving the cursor in this area won't move the image
    this.edgeOffsetX = Math.round((this.containerWidth * (this.containerWidth / this.imageElement.nativeElement.offsetWidth) / 2));
    this.edgeOffsetY = Math.round((this.containerHeight * (this.containerHeight / this.imageElement.nativeElement.offsetHeight) / 2));

    // Setting the clicked position on the center of the container
    const initialLeft = Math.max(0, Math.min((this.clickPosX - (this.containerWidth / 2)), this.maxLeftValue));
    const initialTop = Math.max(0, Math.min((this.clickPosY - (this.containerHeight / 2)), this.maxTopValue));

    // To get the desired effect the values must be set as negative
    this.imageStyles['left'] = -initialLeft + 'px';
    this.imageStyles['top'] = -initialTop + 'px';

    this.cdr.detectChanges();
  }

  /**
   * Gets the cursor coordinates relative to the image
   *
   * @param e
   *
   * @return void
   */
  public getCoordinates(e): void {
    const rect =  e.target.getBoundingClientRect();
    this.posX = Math.max(0, Math.round(e.clientX - rect.left));
    this.posY = Math.max(0, Math.round(e.clientY - rect.top));
  }

  /**
   * When moving the mouse on top of the image overlay we update the image position based on the cursor's position
   *
   * @param e
   *
   * @return void
   */
  public onMouseMove(e): void {
    this.getCoordinates(e);

    const offsetPosX = this.posX - this.edgeOffsetX;
    const offsetPosY = this.posY - this.edgeOffsetY;

    const leftValue = Math.max(0, Math.min((offsetPosX * this.factorX), this.maxLeftValue));
    const topValue = Math.max(0, Math.min((offsetPosY * this.factorY), this.maxTopValue));

    this.imageStyles['left'] = -leftValue.toString() + 'px';
    this.imageStyles['top']  = -topValue.toString() + 'px';
  }
}
